import React from 'react'
import { Link } from 'react-router-dom'

const OperatorSideBar = () => {
    return (
        <div id="sidebar-wrapper" data-simplebar="" data-simplebar-auto-hide="true">
            <div className="brand-logo">
        <span className="user-profile">
            <Link to="/farmer" className="waves-effect text-white">
                <img src="https://farmkonnectng.com/assets/afd/images/fklogo2.png" className="img-circle"
                     alt="user avatar"/>
            </Link>
        </span>
            </div>
            <ul className="sidebar-menu do-nicescrol">
                <li className="text-center m-0 p-0">
                    {/*<i className="fa fa-map-marker fa-3x text-success pl-2" aria-hidden="true"> </i>*/}
                    <Link to="/operator" className="waves-effect text-white">
                        <span>Dashboard</span>
                    </Link>
                </li>

                <hr className="border-success mt-0"></hr>
                <div>
                    <i className="fas fa-tractor fa-3x text-success pl-1"> </i>
                    <span className="text-success p-2">Jobs</span>
                </div>
                <li><Link to="/operator/new_jobs" className="waves-effect pl-3"> <span>All Jobs</span></Link>
                </li>
                <li><Link to="/operator/pending_jobs" className="waves-effect pl-3"> <span>Pending Jobs</span></Link>
                </li>
                <li><Link to="/operator/accepted_jobs" className="waves-effect pl-3"> <span>Accepted Jobs</span></Link>
                </li>
                <li><Link to="/operator/rejected_jobs" className="waves-effect pl-3"> <span>Rejected Jobs</span></Link>
                </li>
                {/* <li><Link to="/operator/job_history" className="waves-effect pl-3">
                    <span>Job History</span></Link></li> */}

                <hr className="border-success"></hr>

                <div>
                    <i className="fas fa-wallet fa-3x text-success pl-2" aria-hidden="true"> </i>
                    <span className="text-success p-3">Wallet</span>
                </div>
                <li><Link to="/operator/view_wallet" className="waves-effect pl-3"> <span>View Wallet</span></Link></li>
                <li><Link to="/operator/request_payout" className="waves-effect pl-3"> <span>Request Payout</span></Link></li>
                <li><Link to="/operator/bank_details" className="waves-effect pl-3"> <span>Bank Details</span></Link></li>

                <hr className="border-success"></hr>
                <div>
                    <i className="fas fa-user-cog fa-3x text-success pl-2" aria-hidden="true"> </i>
                    <span className="text-success p-3">Account Setting</span>
                </div>

                <li><Link to="/operator/profile" className="waves-effect pl-3"> <span>Edit Profile</span></Link></li>
                <li><Link to="/operator/change_password" className="waves-effect pl-3">
                    <span>Change Password</span></Link></li>
            </ul>
        </div>

    )
}

export default OperatorSideBar
